import React, { useEffect, useState } from "react";
import { useApolloClient } from "@apollo/react-hooks";
import { GET_STEP_DETAILS } from "./getStepDetail";
import FieldInfoTooltip from "app/components/FieldInfoTooltip";
const MachineManufacturing = (props) => {
  const client = useApolloClient();
  const [stepDetails, setStepDetails] = useState([]);

  useEffect(() => {
    const GetClientSteps = () => {
      client
        .query({
          query: GET_STEP_DETAILS,
          variables: { step_id: props.StepID },
        })
        .then(({ data }) => {

          setStepDetails(data.getFieldsByStepId);
        })
        .catch((error) => {
          console.log("error", error);
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
    };

    GetClientSteps();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepDetails]);
  return (
    <>
      <p className="input-heading">
        Machine <FieldInfoTooltip info={stepDetails?.[0]?.field_info} />
      </p>
      <div className="data-field">Machine</div>
      <p className="input-heading">
        Component MFG <FieldInfoTooltip info={stepDetails?.[1]?.field_info} />
      </p>

      <div className="data-field">Component MFG</div>
      <p className="input-heading">
        Mode Of Transportation <FieldInfoTooltip info={stepDetails?.[2]?.field_info} />
      </p>

      <div className="data-field">Mode Of Transportation</div>
      <p className="input-heading">
        Distance <FieldInfoTooltip info={stepDetails?.[3]?.field_info} />
      </p>
      <div className="data-field">Distance</div>
      <p className="input-heading">
        Carbon Content Transportation{" "}
        <FieldInfoTooltip info={stepDetails?.[4]?.field_info} />
      </p>
      <div className="data-field">Carbon Content Transportation</div>
      <p className="input-heading">
        Component Assembly <FieldInfoTooltip info={stepDetails?.[5]?.field_info} />
      </p>
      <div className="data-field">Component Assembly</div>
      <p className="input-heading">
        Bound Energy/System <FieldInfoTooltip info={stepDetails?.[6]?.field_info} />
      </p>
      <div className="data-field">Bound Energy/System</div>
    </>
  );
};

export default MachineManufacturing;
